import { Box, HStack, SkeletonCircle, SkeletonText, VStack } from "@reverb-ui/react";

const isLoaded : boolean = false;

export const TopExperienceSkeleton = () : JSX.Element => {
  return (
    <Box
      bg="white"
      width="100%"
      height="full"
      display="flex"
      borderRadius="0.625rem"
      justifyContent="center"
    >
      <Box
        width="85%"
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        marginTop="1.563rem"
      >
        <VStack>
          <HStack display="flex" justifyContent="flex-start" width="full">
            <SkeletonCircle isLoaded={isLoaded} variant="rect" width={4} height={4} />
            <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"50%"} skeletonHeight={"1rem"} />
          </HStack>
          <HStack display="flex" justify="space-between" paddingTop="1.875rem" width="full">
            <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"100%"} skeletonHeight={"2rem"} />
            <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"100%"} skeletonHeight={"2rem"} />
          </HStack>
        </VStack>
        <VStack paddingTop="1.875rem" display="flex" justifyContent="flex-start" height="full">
          {Array(5).fill(0).map((item, index) => (
            <HStack width="full" display="flex" justifyContent="space-between" key={index} paddingBottom="1.4rem">
              <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"75%"} skeletonHeight={"1rem"} />
              <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"15%"} skeletonHeight={"1rem"} />
            </HStack>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};
